module.exports = __webpack_public_path__ + "static/media/our-proejcts-img6.b1894de8.png";